'use strict';

var processInclude = require('./util');

$(function () {
    processInclude(require('./faqs/faqs'));
});
